// How buyers can pay for a tier option: card (Stripe checkout), Swish or
// both. The transactions service stores it as paymentMethods (null = card).
export const PAYMENT_METHOD_CHOICES = ['stripe', 'swish', 'both'];

/** Swish is for one-time tier options in SEK. */
export const canOfferSwish = ({ entityType, paymentType, currency }) =>
  entityType === 'tier' &&
  paymentType === 'one_time' &&
  `${currency || ''}`.toUpperCase() === 'SEK';

/** The form's choice for an option's paymentMethods. */
export const toPaymentMethodChoice = (paymentMethods) => {
  const methods = paymentMethods || [];
  if (!methods.includes('swish')) {
    return 'stripe';
  }
  return methods.includes('stripe') ? 'both' : 'swish';
};

/** paymentMethods to save for the form's choice. */
export const fromPaymentMethodChoice = (choice) => {
  switch (choice) {
    case 'swish':
      return ['swish'];
    case 'both':
      return ['stripe', 'swish'];
    default:
      return null;
  }
};

export const choiceIncludesSwish = (choice) =>
  choice === 'swish' || choice === 'both';
